module.exports = __webpack_public_path__ + "static/media/eye.e63338cc.svg";